'use client';

import { LoadingBackground } from '@core/Components/LoadingBackground/LoadingBackground';
import { Error as ErrorIcon } from '@gds/Icons/Paths/Error';
import { SuccessTickCircle } from '@gds/Icons/Paths/SuccessTickCircle';
import { Typography } from '@gds/Typography/Typography';

import styles from './StatusDisplay.module.css';

export interface StatusDisplayProps {
  leftAlignText?: boolean;
  messages: Record<string, string>;
  type: 'error' | 'success' | 'loading';
}

export const StatusDisplay = ({ messages, type, leftAlignText }: StatusDisplayProps) => {
  const Icon = type === 'success' ? SuccessTickCircle : ErrorIcon;

  return (
    <>
      <div className={styles.resultMessageWrapper}>
        {type === 'loading' ? <LoadingBackground /> : <Icon fontSize={64} />}
        <Typography Component="p" variant="h5" className={styles.resultHeader}>
          {messages.headline}
        </Typography>
      </div>
      {messages.subheading && (
        <Typography
          variant="body1"
          className={`${styles.resultSubhead} ${leftAlignText ? styles.leftAlign : ''}`}
        >
          {messages.subheading}
        </Typography>
      )}
      {messages.description && (
        <Typography
          variant="body3"
          className={`${styles.resultDescription} ${leftAlignText ? styles.leftAlign : ''}`}
        >
          {messages.description}
        </Typography>
      )}
    </>
  );
};
